import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {conversationApi} from '../api';
import {ConversationListItem} from '../model';

const PAGE_SIZE = 50;

interface AdminConversationsFilter {
  search?: string;
  fundId?: string;
  appealId?: string;
}

interface AdminConversationsResult {
  items: ConversationListItem[];
  awaitingCount: number;
  isLoading: boolean;
  error: Error | null;
}

interface ConversationsQueryResult {
  items: ConversationListItem[];
  pageInfo: {hasNextPage: boolean; hasPreviousPage: boolean; startCursor?: string | null; endCursor?: string | null};
  totalCount: number;
}

export const useAdminConversations = (
  filter: AdminConversationsFilter = {},
): AdminConversationsResult => {
  const result: UseQueryResult<ConversationsQueryResult, Error> = useQuery({
    queryKey: ['conversation', 'admin', 'list', filter],
    queryFn: () =>
      conversationApi.getAdminConversations({
        Search: filter.search,
        FundId: filter.fundId,
        AppealId: filter.appealId,
        First: PAGE_SIZE,
        IncludeTotalCount: true,
      }),
    refetchInterval: 15000,
    refetchOnWindowFocus: true,
  });

  const items = result.data?.items ?? [];
  const awaitingCount = items.filter((i) => i.awaitingReply).length;

  return {
    items,
    awaitingCount,
    isLoading: result.isLoading,
    error: result.error,
  };
};
